import { gsap } from "gsap";
import { Power0 } from 'gsap/all';
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import { Intersection } from '@splidejs/splide-extension-intersection';
(function() {
	'use strict'; 

	document.addEventListener('DOMContentLoaded', (event) =>{

		//wait until images, links, fonts, stylesheets, and js is loaded
 		window.addEventListener('load', (e) => {
			
			const carousels = document.querySelectorAll('.carousel-gallery');
			if( carousels ) {
				
				//console.log('Carousels:', carousels, Splide);
				
				//return
				carousels.forEach((element) => {

					const slides = element.querySelectorAll('.splide__slide');

					let autoStart =  element.getAttribute('data-auto-start');
					let showTitle =  element.getAttribute('data-show-titles');
					let perPageAttr =  element.getAttribute('data-per-page');
					let scrollSpeed =  element.getAttribute('data-speed');
					let arrows =  element.getAttribute('data-arrows');
					let lazyload =  element.getAttribute('data-lazyload');
					let pagination =  element.getAttribute('data-pagination');

					if( autoStart === 'true' ) {
						autoStart = true;
					} else {
						autoStart = false;
					}

					if( lazyload === 'true' ) {
						lazyload = true;
					} else {
						lazyload = false;
					}

					if( arrows === 'true' ) {
						arrows = true;
					} else {
						arrows = false;
					}

					if( pagination === 'true' ) {
						pagination = true;
					} else {
						pagination = false;
					}

					if( !perPageAttr ) {
						perPageAttr = 5;
					}

					if( !scrollSpeed ) {
						scrollSpeed = .25;
					} else {
						scrollSpeed = parseFloat(scrollSpeed);
					}

					let direction = scrollSpeed;
					if( element.classList.contains('inverse-direction') ){
						direction = scrollSpeed * -1;
					}

					if( !slides || slides.length <= 0 ) {
						console.error('GALLERY CAROUSEL EMPTY');
						return;
					}

					const primarySlider = new Splide( element, {
						//height : '500px',
						type   : 'loop',
						drag   : 'free',
						focus  : 'center',
						loop		: true,
						rewind		: true,
						cover      	: false,
						perPage: parseInt(perPageAttr),
						gap: 32,
						padding:0,
						lazyLoad: lazyload,
						pagination 	: (slides.length > 3) ? pagination : false,
						arrows     	: (slides.length > 3) ? arrows : false,
						autoScroll: {
							speed: direction,
							autoStart: false,
							pauseOnHover: false
						},
						intersection: {
							inView: {
								autoScroll: autoStart
							},
							outView: {
								autoScroll: false
							},
						},
						/**/
						breakpoints: {
							1440: {
								perPage	: 4
							},
							1280: {
								gap: 30,
								perPage	: 3
							},
							1024: {
								gap: 30,
								perPage	: 2
							},
							768: {
								gap: 20,
								perPage	: 2
							},
							640: {
								gap: 20,
								perPage	: 1
							}
						}
						/**/
					} );

					primarySlider.on( 'ready', function () {
						//console.log('CAROUSEL READY');
					} );

					// Fired right after the carousel moves.
					primarySlider.on( 'visible', function (slide) {
						//console.info('CAROUSEL VISIBLE', slide);

						return;

					} );

					// Fired when any slide gets hidden from the view port.
					primarySlider.on( 'hidden', function (slide) {
						//console.info('CAROUSEL HIDDEN', slide);

						return;
					
					});

					// Fired right before the carousel moves.
					primarySlider.on( 'move', function () {
						console.info('CAROUSEL MOVING');	
					} );

					// Fired right after the carousel moves.
					primarySlider.on( 'moved', function () {
						console.info('CAROUSEL MOVED');
					} );

					primarySlider.mount({ AutoScroll, Intersection });
					//primarySlider.mount(window.splide.Extensions);
					
					/**/
					slides.forEach((slide)=>{
						const pageTransition = document.body.querySelector('e-page-transition');
						slide.addEventListener('click',(evt)=>{
							const target =  evt.currentTarget;
							if( target ) {
								const customLink =  target.getAttribute('data-link');
								
								if( customLink ) {

									if( pageTransition ) {
										pageTransition.classList.remove('e-page-transition--entered');
										pageTransition.classList.add('e-page-transition--exiting');
									}

									const tt = setTimeout(()=>{
										window.location = customLink;
										clearTimeout(tt);
									}, 750);
									
								}
							}
							
						});
					});
					/**/
					
					
				});
			}

		}, false);

	});

})();
